/* eslint-disable */
import {Service} from 'components/Shared/server';
import {CustomerPageRegister} from 'models/CustomerPageRegister';
import {CustomerPageCredentials} from 'models/CustomerPageCredentials';
import {CustomerPageResetPassword} from 'models/CustomerPageResetPassword';
import {CustomerPageNewPassword} from 'models/CustomerPageNewPassword';
import {OrderIdentifier} from 'models/OrderIdentifier';
import {CustomerPageChangePassword} from 'models/CustomerPageChangePassword';
import {CustomerPageOrderlistResponse} from 'models/CustomerPageOrderlistResponse';
import {CustomerOrder} from 'models/CustomerOrder';


export const routePostDoRegister = () => `/api/customerpage/saveregister`;
export function postDoRegister(regForm: CustomerPageRegister): Promise<Response> {
  return Service.post<Response>({
    url: routePostDoRegister(),
    body: regForm
  });
}

export const routePostLogin = () => `/api/customerpage/login`;
export function postLogin(credentials: CustomerPageCredentials): Promise<Response> {
  return Service.post<Response>({
    url: routePostLogin(),
    body: credentials
  });
}

export const routePostResetPassword = () => `/api/customerpage/resetpassword`;
export function postResetPassword(request: CustomerPageResetPassword): Promise<Response> {
  return Service.post<Response>({
    url: routePostResetPassword(),
    body: request
  });
}

export const routePostSaveNewPassword = () => `/api/customerpage/savenewpassword`;
export function postSaveNewPassword(request: CustomerPageNewPassword): Promise<Response> {
  return Service.post<Response>({
    url: routePostSaveNewPassword(),
    body: request
  });
}

export const routePostAddOrdersToUser = () => `/api/customerpage/addorders`;
export function postAddOrdersToUser(request: OrderIdentifier): Promise<Response> {
  return Service.post<Response>({
    url: routePostAddOrdersToUser(),
    body: request
  });
}

export const routePostChangePassword = () => `/api/customerpage/account/changepassword`;
export function postChangePassword(request: CustomerPageChangePassword): Promise<Response> {
  return Service.post<Response>({
    url: routePostChangePassword(),
    body: request
  });
}

export const routePostLogout = () => `/api/customerpage/logout`;
export function postLogout(): Promise<Response> {
  return Service.post<Response>({
    url: routePostLogout(),
    body: null
  });
}

export const routeGetGetOrders = (page?: number) => `/api/customerpage/orders?page=${page}`;
export function getGetOrders(page?: number): Promise<CustomerPageOrderlistResponse> {
  return Service.get<CustomerPageOrderlistResponse>({
    url: routeGetGetOrders(page)
  });
}

export const routeGetGetOrderData = (orderId: string) => `/api/customerpage/orderdata?orderId=${encodeURIComponent(orderId)}`;
export function getGetOrderData(orderId: string): Promise<CustomerOrder> {
  return Service.get<CustomerOrder>({
    url: routeGetGetOrderData(orderId)
  });
}
